/* unplugin-vue-components disabled */import script from "./FullScreenTip.vue?vue&type=script&setup=true&lang=js"
export * from "./FullScreenTip.vue?vue&type=script&setup=true&lang=js"

import "./FullScreenTip.vue?vue&type=style&index=0&id=62d4d771&lang=less"

const __exports__ = script;

export default __exports__